// import showHeaderEditor from "@/views/system/dashboard-design/charts/property-editor/showHeader-editor.vue";
// import titleEditor from "@/views/system/dashboard-design/charts/property-editor/title-editor.vue";
// import showFullscreenEditor from "@/views/system/dashboard-design/charts/property-editor/showFullscreen-editor.vue";
// import showRefreshEditor from "@/views/system/dashboard-design/charts/property-editor/showRefresh-editor.vue";
// import showCollapseEditor from "@/views/system/dashboard-design/charts/property-editor/showCollapse-editorvue.vue";
// import showIconEditor from "@/views/system/dashboard-design/charts/property-editor/showIcon-editor.vue";
// import showDataEnitiyEditor from "@/views/system/dashboard-design/charts/property-editor/dataEnitiy-editor.vue";

export var registerChartLibProperties = function registerChartLibProperties(app, PERegister) {
  // PERegister.registerCommonProperty('showHeader', 'showHeader-editor')
  // PERegister.registerCommonProperty('title', 'title-editor')
  // PERegister.registerCommonProperty('fullscreen', 'fullscreen-editor')
  // PERegister.registerCommonProperty('showRefresh', 'showRefresh-editor')
  // PERegister.registerCommonProperty('showCollapse', 'showCollapse-editor')
  // PERegister.registerCPEditor(app, 'showDataEnitiy', 'showDataEnitiy-editor', showDataEnitiyEditor)
  // PERegister.registerCPEditor(app, 'showHeader', 'showHeader-editor', showHeaderEditor)
  // PERegister.registerCPEditor(app, 'title', 'title-editor', titleEditor)
  // PERegister.registerCPEditor(app, 'showFullscreen', 'showFullscreen-editor', showFullscreenEditor)
  // PERegister.registerCPEditor(app, 'showRefresh', 'showRefresh-editor', showRefreshEditor)
  // PERegister.registerCPEditor(app, 'showCollapse', 'showCollapse-editor', showCollapseEditor)
  // PERegister.registerCPEditor(app, 'showIcon', 'showIcon-editor', showIconEditor)

  // 组件排序
  var comOrder = ['dataEntity', 'setDimensional', 'setChartFilter', 'showHeader', 'showFullscreen', 'showRefresh', 'chartStyle', 'axisCoordinates', 'setChartStyle', 'setChartConf', 'setQuickNavConf'];
  var newCom = [];
  var modules = require.context('./', false, /\w+\.vue$/);
  modules.keys().map(function (fileName) {
    var cname = modules(fileName).default.name;
    var alias = cname.split('-')[0];
    var com = {};
    var inx = comOrder.indexOf(alias);
    if (inx != -1) {
      com.alias = alias;
      com.cname = cname;
      com.default = modules(fileName).default;
      newCom[inx] = com;
    }
  });
  newCom.forEach(function (el) {
    PERegister.registerCPEditor(app, el.alias, el.cname, el.default);
  });
};
export var registerPEWidgets = function registerPEWidgets(app) {
  var requireComponent = require.context('./', false, /\w+\.vue$/);
  requireComponent.keys().map(function (fileName) {
    var comp = requireComponent(fileName).default;
    app.component(comp.name, comp);
  });
};